import {DataStatus, Tabs} from 'platform/components';

import {RefObject} from 'react';

import {isNilOrEmpty} from 'ramda-adjunct';

import {useGetServiceOrderIntegrationsQuery} from '@dms/api/workshop';
import i18n from '@dms/i18n';

import {suffixTestId, TestIdProps} from 'shared/web';

import {useIntegrationsEnabled} from '../../pages/ServiceCaseDetail/hooks/useIntegrationsEnabled';
import {EditItemAdditionalInformation} from './components/EditItemAdditionalInformation';
import {EditItemForm} from './components/EditItemForm';

const BASIC_INFORMATION = 'BASIC_INFORMATION';
const ADDITIONAL_INFORMATION = 'ADDITIONAL_INFORMATION';

interface EditItemProps extends TestIdProps {
  itemId: string;
  serviceCaseId: string;
  serviceOrderId: string;
  serviceJobId: string;
  onClose: VoidFunction;
  isSavedByRowControlRef?: RefObject<boolean>;
  formRef?: RefObject<{
    submit: () => Promise<boolean>;
    isDirty: boolean;
  } | null>;
}

export function EditItem(props: EditItemProps) {
  const {
    data: serviceOrderIntegrations,
    isLoading: isServiceOrderIntegrationsLoading,
    isError: isServiceOrderIntegrationsError,
  } = useGetServiceOrderIntegrationsQuery(
    {
      serviceCaseId: props.serviceCaseId,
      serviceOrderId: props.serviceOrderId,
    },
    {skip: isNilOrEmpty(props.serviceCaseId) || isNilOrEmpty(props.serviceOrderId)}
  );

  const {isClaraIntegrationEnabled} = useIntegrationsEnabled({
    serviceCaseId: props.serviceCaseId,
    orderIntegrations: serviceOrderIntegrations ?? {orderIntegration: []},
  });

  return (
    <DataStatus
      isLoading={isServiceOrderIntegrationsLoading}
      isError={isServiceOrderIntegrationsError}
    >
      <Tabs
        tabs={[
          {
            content: <EditItemForm {...props} />,
            title: i18n.t('general.labels.basicInformation'),
            id: BASIC_INFORMATION,
          },
          {
            content: (
              <EditItemAdditionalInformation
                orderId={props.serviceOrderId}
                serviceCaseId={props.serviceCaseId}
                serviceJobId={props.serviceJobId}
                serviceItemId={props.itemId}
                data-testid={suffixTestId('additional-information', props)}
              />
            ),
            title: i18n.t('general.labels.additionalInformation'),
            id: ADDITIONAL_INFORMATION,
            isDisabled: !isClaraIntegrationEnabled,
          },
        ]}
        variant="condensed"
      />
    </DataStatus>
  );
}
